<div
  class="dynamic-field form-input"
  [ngClass]="[config.name + '-container', isRequired ? 'dynamic-field--required' : '']"
  [formGroup]="group"
>
  <cwc-input-date
    [label]="config.label | translate"
    [formControl]="fieldControl"
    [disabledDates]="disabledDates"
    [attr.data-test]="config?.dataTId"
    [attr.data-tid]="config?.dataTId"
    [attr.data-name]="config?.name"
    [minDate]="min"
    [status]="fieldControl.invalid && !fieldControl.untouched ? 'error' : ''"
    [statusMessage]="fieldControl.hasError('required') ? ('forms.required' | translate) : ''"
    [maxDate]="max"
    [language]="languageStore"
    [rtl]="rtl"
    [returnFormat]="'date'"
    [hideOutsideDays]="true"
  >
  </cwc-input-date>
</div>
